import { FC, useState } from 'react';
import { IconNames } from 'components/Icon';
import { showToast } from 'components/Toast';
import { copyToClipboard } from 'helpers/clipboard';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';
import { BadgeCtaCard } from './BadgeCtaCard';
import { EmbedBadgePopup } from './EmbedBadgePopup';

const SCREEN: DashboardScreen = 'recipients_dashboard';

interface EmbedBadgeCtaProps {
  impactScore: number;
  fundraisingUrl: string;
  badgeUrl: string;
  refParam: string;
}

export const EmbedBadgeCta: FC<EmbedBadgeCtaProps> = ({
  impactScore,
  fundraisingUrl,
  badgeUrl,
  refParam,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const snippet = `<a href="${fundraisingUrl}${refParam}" target="_blank" rel="noopener noreferrer"><img src="${badgeUrl}" alt="Impact Score ${impactScore.toFixed(1)} out of 10" /></a>`;

  const handleOpen = () => {
    trackEvent('Embed Badge Popup Opened', { screen: SCREEN });
    setIsPopupOpen(true);
  };

  const handleCopy = () => {
    copyToClipboard(snippet)
      .then(() => {
        trackEvent('Embed Badge Copied', { screen: SCREEN });
        showToast('Copied! Paste it into your site or email footer.', 'success');
      })
      .catch(() => {
        showToast('Failed to copy snippet. Please copy it manually.', 'error');
      });
  };

  return (
    <>
      <BadgeCtaCard
        icon={IconNames.Embed}
        title="Embed your badge"
        description="Copy a code snippet with your score & embed on your site or email footer."
        action={
          <button
            type="button"
            className="btn-inkBlue btn btn-secondary"
            onClick={handleOpen}
            aria-label="Open the badge embed snippet"
          >
            <span className="body-small-text text-white">Embed Badge</span>
          </button>
        }
      />
      <EmbedBadgePopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        snippet={snippet}
        onCopy={handleCopy}
      />
    </>
  );
};
